export const NO_SELECTION_DROPDOWN_VALUE = "no-select";
